import React, { useState, useEffect, Fragment } from 'react';
import { createRoot } from 'react-dom/client';

import ShareModalContent from '../сompetitive-intelligence-reports/shared/components/ShareModalContent';
import Modal from '../../../components/Modal';

const rootNode = document.querySelector('#thank-you-report');

const ShareReportModal = () => {
  const [show, setShow] = useState(false);
  const onClose = () => setShow(false);
  const requestUrl = window.location.search.split('&share_url=')[0].split('request_url=')[1];
  const shareUrl = window.location.search.split('&share_url=')[1];
  useEffect(() => {
    const modalAnchor = document.querySelector('.thank-you-report .headline-text-button-next-subheadline');
    if (modalAnchor && Boolean(requestUrl)) modalAnchor.addEventListener('click', () => setShow(true));
  }, []);

  return (
    <Modal
      open={show}
      size="xs"
      hideCloseButton
      shouldCloseOnOverlayClick={false}
      modalClassName="share-report-modal"
      onClose={onClose}
    >
      {show && (
        <Fragment>
          <header className="share-report-modal__header">
            <p className="share-report-modal__header-title">Share Report</p>
            <span className="hicon-close" onClick={onClose} />
          </header>
          <ShareModalContent
            shareUrl={shareUrl}
            requestUrl={requestUrl}
            onHide={onClose}
          />
        </Fragment>
      )}
    </Modal>
  );
};

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(rootNode);
  root.render(<ShareReportModal />);
});

